import React from 'react';
import { Link } from 'react-router-dom';


import { useDispatch, useSelector } from 'react-redux';
// import { useLocation, useHistory } from 'react-router-dom';

import Notify from '../../../components/Notify/Notify';
import ModalProfileMenu from '../../../components/Modals/ModalProfileMenu/ModalProfileMenu';

import ModalPricingPlanLimit from '../../../components/Modals/ModalPricingPlanLimit/ModalPricingPlanLimit';
import ModalPricingPlanUpgrade from '../../../components/Modals/ModalPricingPlanUpgrade/ModalPricingPlanUpgrade';

import ModalInviteToApp from '../../../components/Modals/ModalInvitePeople/ModalInvitePeople';
import ModalFeedbackThanks from '../../../components/Modals/ModalFeedbackThanks/ModalFeedbackThanks';

import Sidebar from '../_components/Sidebar/Sidebar';
import Header from '../_components/Header/Header';

import '../MainApp.scss';
import './Settings.scss';

const Settings = () => {
    document.title = 'Settings | DB Design';

    const dispatch = useDispatch();
    // const history = useHistory();

    const handleClick = (e) => {
        // history.push(`/diagram/sdf`);
    };

    return (
        <div className="dash-container settings-page">
            <Sidebar />
            <div className='dash-main'>

                {/* common modals */}
                <Notify viewType='main' />
                <ModalProfileMenu />

                <ModalPricingPlanLimit />
                <ModalPricingPlanUpgrade />

                <ModalInviteToApp />
                <ModalFeedbackThanks />

                {/* page components */}

                <Header title='Settings'>
                    {/* <button className='dash-main-header-button prime' onClick={(e) => { handleClick(e); }}>Request</button> */}
                </Header>

                <div className='dash-main-body'>

                    <div className='selection-group'>
                        <div className={`selection-item selected`}>Profile</div>
                        {/* <div className={`selection-item`}>Account</div> */}
                        <div className={`selection-item`}>Preferences</div>


                        {/* <div className={`selection-item ${selectedType === 'all' ? 'selected' : ''}`} onClick={() => handleSelectType('all')}>All</div>
                        <div className={`selection-item ${selectedType === 'mydiagrams' ? 'selected' : ''}`} onClick={() => handleSelectType('mydiagrams')}>My diagrams</div>
                        <div className={`selection-item ${selectedType === 'shared' ? 'selected' : ''}`} onClick={() => handleSelectType('shared')}>Shared with me</div>
                        {filterData(diagrams, 'archived')?.length ?
                            <React.Fragment>
                                <div className="selection-item-slash"></div>
                                <div className={`selection-item ${selectedType === 'archived' ? 'selected' : ''}`} onClick={() => handleSelectType('archived')}>Archived diagrams</div>
                            </React.Fragment>
                            : ''} */}
                    </div>








                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title'>Account Details</div>
                            {/* <span className='section-left-subtitle'>Update your personal details here.</span> */}
                        </div>
                        <div className='section-right'></div>
                    </div>

                    {/* <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Nickname</div>
                            <span className='section-left-subtitle'>This will be displayed on your profile. Visible for you and your team.</span>
                        </div>
                        <div className='section-right'></div>
                    </div> */}

                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Name</div>
                            <span className='section-left-subtitle'>This will be displayed on your profile. Visible for you and your team.</span>
                        </div>
                        <div className='section-right'></div>
                    </div>

                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Email address</div>
                            <span className='section-left-subtitle'>Your account email address.</span>
                        </div>
                        <div className='section-right'></div>
                    </div>



                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title'>Preferences</div>
                            {/* <span className='section-left-subtitle'>Update your personal details here.</span> */}
                        </div>
                        <div className='section-right'></div>
                    </div>

                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Color Theme</div>
                            <span className='section-left-subtitle'>Select or customize your UI theme.</span>
                        </div>
                        <div className='section-right'></div>
                    </div>

                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Language</div>
                            <span className='section-left-subtitle'>Select interface language.</span>
                        </div>
                        <div className='section-right'></div>
                    </div>

                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Date Format</div>
                            <span className='section-left-subtitle'>Select date format.</span>
                        </div>
                        <div className='section-right'></div>
                    </div>



                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title'>Dangerous Zone</div>
                            {/* <span className='section-left-subtitle'>Update your personal details here.</span> */}
                        </div>
                        <div className='section-right'></div>
                    </div>

                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Delete Account</div>
                            <span className='section-left-subtitle'>Update your personal details here.</span>
                        </div>
                        <div className='section-right'></div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Settings;
